import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_3 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/OrderItem.vue';
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtFieldPc.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtFieldPc.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "background": "#fff",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "haeder",
    style: _vm.style
  }), _c('tab', {
    staticClass: "tab-effect",
    attrs: {
      "default-color": "#1a1e24",
      "active-color": "#3ccba6",
      "bar-active-color": "#3ccba6",
      "custom-bar-width": "60px",
      "line-width": 3
    },
    model: {
      value: _vm.tabsIndex,
      callback: function ($$v) {
        _vm.tabsIndex = $$v;
      },
      expression: "tabsIndex"
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v(i18n.tc("226"))]), _vm.ids.cpId ? _c('tab-item', [_vm._v(i18n.tc("667"))]) : _vm._e(), _vm.isShowHistoryOrder && _vm.ids.cpId ? _c('tab-item', [_vm._v(i18n.tc("208"))]) : _vm._e()], 1), _c('Swiper', {
    staticClass: "swiper",
    attrs: {
      "show-dots": false,
      "threshold": 100,
      "height": "100%"
    },
    model: {
      value: _vm.tabsIndex,
      callback: function ($$v) {
        _vm.tabsIndex = $$v;
      },
      expression: "tabsIndex"
    }
  }, [_c('SwiperItem', [_c('ViewBox', {
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c('div', [_c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("209"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.corporationdata.product_name))])]), _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("454"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.corporationdata.code))])]), _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("455"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.corporationdata.model))])]), _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("456"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.corporationdata.typeName))])]), _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("457"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.code))])]), _c('div', {
    staticClass: "content canping"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "extFields": _vm.extFields
    }
  })], 1)], 1)])], 1), _vm.ids.cpId ? _c('SwiperItem', [_c('ViewBox', {
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c('div', [_vm.codeMap['420013'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("198"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.customer_name))])]) : _vm._e(), _vm.codeMap['420012'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("210"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.production_sn))])]) : _vm._e(), _vm.codeMap['420014'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("211"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.detail_addr))])]) : _vm._e(), _vm.codeMap['420002'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("200"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.warranty_start_date))])]) : _vm._e(), _vm.codeMap['420001'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("201"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.warranty_end_date))])]) : _vm._e(), _vm.codeMap['420001'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("212"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(" " + _vm._s(['', i18n.tc("213"), i18n.tc("214"), i18n.tc("215")][+_vm.customerProductDetail.customerPro.warrantyState]) + " ")])]) : _vm._e(), _vm.codeMap['420006'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("202"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.purchasing_date))])]) : _vm._e(), _vm.codeMap['420004'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("203"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.delivery_date))])]) : _vm._e(), _vm.codeMap['420005'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("204"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.install_date))])]) : _vm._e(), _vm.codeMap['420003'] ? _c('group', {
    staticClass: "canping"
  }, [_c('span', {
    staticClass: "canpingleft"
  }, [_vm._v(i18n.tc("205"))]), _c('span', {
    staticClass: "canpingright"
  }, [_vm._v(_vm._s(_vm.customerProductDetail.customerPro.production_date))])]) : _vm._e(), _c('div', {
    staticClass: "content canping"
  }, [_c(__unplugin_components_1, {
    attrs: {
      "extFields": _vm.customerProductDetail.fvs
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm.isShowHistoryOrder && _vm.ids.cpId ? _c('SwiperItem', [_c(__unplugin_components_2, {
    ref: "corporationdataunfalgs",
    staticClass: "ScrollerListHeight",
    attrs: {
      "is-px": "",
      "height": _vm.scrollerHight,
      "total": _vm.corporationdataunfalgs.length
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, _vm._l(_vm.corporationdataunfalgs, function (item) {
    return _c(__unplugin_components_3, {
      key: item.orderId,
      attrs: {
        "is-card": "",
        "abnormal": item.abnormal_state === 1 ? 1 : 0,
        "status": item.state,
        "evaluate": item.evaluate_state,
        "time": item.custom_apply_time,
        "examine": item.examine_submit_state
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.handleJump(item);
        }
      }
    }, [_c('img', {
      attrs: {
        "slot": "temp-icon",
        "src": item.tmpl_img_url || '/spa_static/templateIcon/template-10-0.png',
        "width": "100%",
        "height": "100%"
      },
      slot: "temp-icon"
    }), _c('div', {
      staticClass: "smy__text-overflow-one-line",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('template', {
      slot: "no"
    }, [_vm._v(i18n.tc("216") + _vm._s(item.order_no))]), item.o_appointment_display_list === 0 ? _c('template', {
      slot: "time"
    }, [_vm._v(" " + i18n.tc("217") + _vm._s(item.custom_apply_time) + " ")]) : _vm._e(), item.o_service_address_display_list === 1 ? _c('template', {
      slot: "address"
    }, [_c('div', {
      staticClass: "smy__text-overflow-one-line"
    }), _vm._v(" " + i18n.tc("218") + _vm._s(item.gps_addr) + _vm._s(item.custom_detail_addr || '') + " ")]) : _vm._e(), _c('div', {
      staticClass: "one-line-text font-size-h4-large"
    }, [_vm._v(i18n.tc("219") + _vm._s(item.tmpl_name) + " - " + _vm._s(item.order_label))]), item.fieldList && item.fieldList.length > 0 ? _vm._l(item.fieldList, function (field, index) {
      return _c('div', {
        key: index,
        staticClass: "one-line-text font-size-h4-large"
      }, [_vm._v(" " + _vm._s(field.name) + "：" + _vm._s(field.value === '' || field.value === null ? '-' : field.value) + " ")]);
    }) : _vm._e()], 2);
  }), 1)], 1) : _vm._e()], 1), _vm.adddata.length ? _c('div', {
    staticClass: "addcorporation"
  }, [_c('x-button', {
    staticStyle: {
      "background": "transparent"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.shareshow.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "addimg",
    attrs: {
      "src": require("@/assets/icon/sharea.jpg"),
      "alt": ""
    }
  })])], 1) : _vm._e(), _c('div', [_c('Popup', {
    staticClass: "shareall-popup",
    model: {
      value: _vm.sharefalg,
      callback: function ($$v) {
        _vm.sharefalg = $$v;
      },
      expression: "sharefalg"
    }
  }, [_c('div', {
    staticClass: "share"
  }, [_c('div', {
    staticClass: "shareflex"
  }, _vm._l(_vm.adddata, function (item, i) {
    return _c('div', {
      key: i,
      staticClass: "shareitem-flex",
      on: {
        "click": function ($event) {
          _vm.$router.push({
            name: 'ServiceDetail',
            query: {
              id: item.hsId,
              productId: String(_vm.ids.pId),
              cpId: _vm.ids.cpId
            }
          });
        }
      }
    }, [_c('img', {
      staticClass: "shareitemimg",
      attrs: {
        "src": item.logo || '/spa_static/editIcon/server-1.png',
        "alt": i18n.tc("69")
      }
    }), _c('div', {
      staticClass: "smy__text-overflow-one-line"
    }, [_vm._v(" " + _vm._s(item.service_item_name) + " ")])]);
  }), 0), _c('x-button', {
    staticClass: "sharebut",
    nativeOn: {
      "click": function ($event) {
        return _vm.sharecancel.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("11"))])], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };